<template>
  <div class="salesHome">
    <div class="salesHome_top">
      <div class="salesHome_top_background">
        <div class="salesHome_top_title">
          <span>One-stop</span> apps integration
        </div>
        <div class="salesHome_top_subtitle">
          Increase your sales with <span>one-click!</span>
        </div>
        <div class="salesHome_top_button">
          <div
            class="salesHome_top_button_1"
            @click="goLink('https://apps.shopify.com/salesdish')"
          >
            Start your 14-day free trial
          </div>
          <div
            class="salesHome_top_button_2"
            @click="goLink('https://your-redbubble.myshopify.com/')"
          >
            <span>View example store</span>
            <img src="../assets/golink.svg" alt="" />
          </div>
        </div>
        <img src="../assets/home1.svg"  class="salesHome_topimg" v-if="ismobile"/>
      </div>
    </div>

    <div class="salesHome_difficulties">
      <div class="salesHome_difficulties_box">
        <div class="salesHome_difficulties_title">
          We clearly know difficulties of operating a store!
        </div>
        <div class="salesHome_difficulties_content_1">
          <div class="salesHome_difficulties_content_title">
            I am a novice seller, I am worried about...
          </div>
          <div v-if="ismobile==false">
             <div class="salesHome_difficulties_content_img">
            <img src="../assets/salesHome_difficulties_1.svg" />
          </div>
          <div class="salesHome_difficulties_content_text d1">
            <img
              src="../assets/salesHome_difficulties_text1.svg"
              class="salesHome_difficulties_content_text_img"
            />
            How to make my store look more <span>attractive</span>?
          </div>
          <div class="salesHome_difficulties_content_text d2">
            <img
              src="../assets/salesHome_difficulties_text2.svg"
              class="salesHome_difficulties_content_text_img"
            />
            How to turn visitors into <span>regular customers</span>?
          </div>
          <div class="salesHome_difficulties_content_text d3">
            <img
              src="../assets/salesHome_difficulties_text3.svg"
              class="salesHome_difficulties_content_text_img"
            />
            How to reduce <span>cart</span> abandonment?
          </div>
          <div class="salesHome_difficulties_content_text d4">
            <img
              src="../assets/salesHome_difficulties_text4.svg"
              class="salesHome_difficulties_content_text_img"
            />
            How to build <span>trust</span> with customers?
          </div>
          </div>
          <img src="../assets/home2.svg" alt="" v-else>
        </div>
        <div class="salesHome_difficulties_content_2">
          <div class="salesHome_difficulties_content_title">
            I'm a senior seller, worried...
          </div>
          <div v-if="ismobile==false" >
             <div
            class="
              salesHome_difficulties_content_img
              salesHome_difficulties_content_img2
            "
          >
            <img src="../assets/salesHome_difficulties_2.svg" />
          </div>
          <div class="salesHome_difficulties_content_text d5">
            <img
              src="../assets/salesHome_difficulties_text5.svg"
              class="salesHome_difficulties_content_text_img"
            />
            How to make my customers have a better
            <span>shopping experience</span>?
          </div>
          <div class="salesHome_difficulties_content_text d6">
            <img
              src="../assets/salesHome_difficulties_text6.svg"
              class="salesHome_difficulties_content_text_img"
            />
            How to get more <span>potential customers</span>?
          </div>
          <div class="salesHome_difficulties_content_text d7">
            <img
              src="../assets/salesHome_difficulties_text7.svg"
              class="salesHome_difficulties_content_text_img"
            />
            How to make my store <span>look more attractive</span>?
          </div>
          <div class="salesHome_difficulties_content_text d8">
            <img
              src="../assets/salesHome_difficulties_text8.svg"
              class="salesHome_difficulties_content_text_img"
            />
            How to conduct more <span>marketing activities</span>?
          </div>
          </div>
          <img src="../assets/home3.svg"  v-else alt="">
        </div>
      </div>
    </div>

    <div class="salesHome_solve">
      <div class="salesHome_solve_box">
        <div class="salesHome_solve_title">
          Salesdish to help you solve all-round problems in one stop.
        </div>
        <div class="salesHome_solve_subtitle">
          Whether you're a total novice seller or an experienced seller with
          millions of dollars in turnover, we have exact solution you're looking
          for!
        </div>
        <div class="salesHome_solve_prepare">
          <div class="salesHome_solve_prepare_img">
            <div class="salesHome_solve_prepare_title">
              For novice sellers, we have prepared..
            </div>
            <img src="../assets/salesHome_solve1.svg" v-if="ismobile==false"/>
          </div>
          <div class="salesHome_solve_prepare_content">
            <div class="salesHome_solve_prepare_subtitle">
              <div></div>Improve conversion
            </div>
            <div class="salesHome_solve_prepare_subtitle_box">
              <div class="salesHome_solve_prepare_text">
                <img src='../assets/home4.svg' alt=""/>Cart drawer
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Recently sales notice
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Cart FAB
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Recently viewed
              </div>
            </div>
            <div class="salesHome_solve_prepare_line"></div>
            <div class="salesHome_solve_prepare_subtitle">
               <div></div>Decorate your store
            </div>
            <div class="salesHome_solve_prepare_subtitle_box">
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Add to cart button animation
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Checkout button animation
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Emojis/images falling
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Add to cart button ribbon
              </div>
            </div>
            <div class="salesHome_solve_prepare_line"></div>
            <div class="salesHome_solve_prepare_subtitle">
               <div></div>Reduce abandonment
            </div>
            <div class="salesHome_solve_prepare_subtitle_box">
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Quickly checkout
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Inactive tab title recall
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Favicon cart count
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Cart items count in tab title
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Cart reserved timer
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Hide dynamic checkout button
              </div>
            </div>
            <div class="salesHome_solve_prepare_line"></div>
            <div class="salesHome_solve_prepare_subtitle"> <div></div>Build trust</div>
            <div class="salesHome_solve_prepare_subtitle_box">
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Payment method icon
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Current visitors counter
              </div>
            </div>
          </div>
           <img src="../assets/salesHome_solve1.svg" class="salesHome_solveimg" v-if="ismobile==true"/>
        </div>
        <div class="salesHome_solve_prepare salesHome_solve_prepare2">
          <div class="salesHome_solve_prepare_img">
            <div
              class="
                salesHome_solve_prepare_title
                salesHome_solve_prepare_title_right
              "
            >
              For senior sellers, we have prepared..
            </div>
            <img src="../assets/salesHome_solve2.svg"  v-if="ismobile==false" />
          </div>
          <div
            class="
              salesHome_solve_prepare_content salesHome_solve_prepare_content2
            "
          >
            <div class="salesHome_solve_prepare_subtitle">
              <div></div>Protect your store
            </div>
            <div class="salesHome_solve_prepare_subtitle_box">
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Cookies Bar
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Best selling protection
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Prevent user operation
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Terms of service confirmation
              </div>
            </div>
            <div class="salesHome_solve_prepare_line"></div>
            <div class="salesHome_solve_prepare_subtitle">
              <div></div>Improve experience
            </div>
            <div class="salesHome_solve_prepare_subtitle_box">
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Quick admin bar
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Scroll to top button
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> New tab open link
              </div>
            </div>
            <div class="salesHome_solve_prepare_line"></div>
            <div class="salesHome_solve_prepare_subtitle">
               <div></div>Capture customers
            </div>
            <div class="salesHome_solve_prepare_subtitle_box">
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> CTA pop-ups
              </div>
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Announcement bar
              </div>
            </div>
            <div class="salesHome_solve_prepare_line"></div>
            <div class="salesHome_solve_prepare_subtitle">
               <div></div>Increase income
            </div>
            <div class="salesHome_solve_prepare_subtitle_box">
              <div class="salesHome_solve_prepare_text">
                 <img src='../assets/home4.svg' alt=""/> Upsell in cart
              </div>
            </div>
          </div>
           <img src="../assets/salesHome_solve2.svg"  class="salesHome_solveimg2"  v-if="ismobile==true" />
        </div>
      </div>
    </div>

    <div class="salesHome_install">
      <div class="salesHome_install_box">
        <div class="salesHome_install_content">
          <div class="salesHome_install_text">
            <div class="salesHome_install_title">
              Install Salesdish.<br />
              Unlimited possibilities for your store.
            </div>
            <div class="salesHome_install_subtitle">
              The installation is a one click process and is super easy to get
              up and running quickly!
            </div>
          </div>
          <div class="salesHome_install_button">
            <div
              class="salesHome_install_button_text"
              @click="goLink('https://apps.shopify.com/salesdish')"
            >
              Start your 14-day free trial
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="salesHome_app">
      <div class="salesHome_app_box">
        <div class="salesHome_app_title">
          There are more than 30 apps under development.<br />
          We have everything you need…
        </div>
        <div class="salesHome_app_content">
          <div class="salesHome_app_content_box">
            <img src="../assets/salesHome_app_img1.svg" />
            <div class="salesHome_app_content_title">Countdown timer</div>
            <div class="salesHome_app_content_subtitle">
              Display a sales countdown timer in your store to increase
              customers tension.
            </div>
          </div>
          <div class="salesHome_app_content_box">
            <img src="../assets/salesHome_app_img2.svg" />
            <div class="salesHome_app_content_title">Stock countdown</div>
            <div class="salesHome_app_content_subtitle">
              Let customers see shortage of inventory intuitively and place
              orders as soon as possible.
            </div>
          </div>
          <div class="salesHome_app_content_box">
            <img src="../assets/salesHome_app_img3.svg" />
            <div class="salesHome_app_content_title">Pre-Orders</div>
            <div class="salesHome_app_content_subtitle">
              Create a pre-order function for your store.
            </div>
          </div>
          <div class="salesHome_app_content_box">
            <img src="../assets/salesHome_app_img4.svg" />
            <div class="salesHome_app_content_title">Wheel of fortune</div>
            <div class="salesHome_app_content_subtitle">
              Invite customers to enter their email to <br />participate in
              discount coupon lottery to capture more potential customers and
              boost conversion rate.
            </div>
          </div>
          <div class="salesHome_app_content_box">
            <img src="../assets/salesHome_app_img5.svg" />
            <div class="salesHome_app_content_title">Custom badge</div>
            <div class="salesHome_app_content_subtitle">
              Add a service pledge badge on the product page, you can customize
              badge style and text content.
            </div>
          </div>
          <div class="salesHome_app_content_box">
            <img src="../assets/salesHome_app_img6.svg" />
            <div class="salesHome_app_content_title">
              Login via social accounts
            </div>
            <div class="salesHome_app_content_subtitle">
              Allow customers to quickly log in using social accounts in your
              store.
            </div>
          </div>
        </div>
        <div class="salesHome_app_subtitle">
          Please look forward to more content…
        </div>
      </div>
    </div>

    <div class="salesHome_support">
      <div class="salesHome_support_box">
        <div class="salesHome_support_title">
          Not sure which apps to choose? Our team is always ready to support!
        </div>
        <div class="salesHome_support_content">
          <div class="salesHome_support_team">
            <img src="../assets/home5.svg" />
          </div>
          <div class="salesHome_support_button" @click="liveChat">
            Live Chat
          </div>
        </div>
      </div>
    </div>

    <div class="salesHome_enjoy">
      <div class="salesHome_enjoy_box">
        <div class="salesHome_enjoy_title">
          <div class="salesHome_enjoy_title_text">
            <div class="salesHome_enjoy_title_title">
              Only $19.9, you can enjoy Salesdish.
            </div>
            <div class="salesHome_enjoy_title_subtitle">
              One bill to meet all your needs.
            </div>
          </div>
          <div
            class="salesHome_enjoy_title_button"
            @click="goLink('https://apps.shopify.com/salesdish')"
          >
            Start your 14-day free trial
          </div>
        </div>
        <div class="salesHome_enjoy_content">
          <div class="salesHome_enjoy_content_box1">
            <img src="../assets/salesHome_enjoy_salesdish.svg" />
            <div class="salesHome_enjoy_content_box1_title">
              $19.9<span>/mo</span>
            </div>
            <div class="salesHome_enjoy_content_box1_line"></div>
            <div class="salesHome_enjoy_content_box1_text">Recently viewed</div>
            <div class="salesHome_enjoy_content_box1_text">
              Recently sales notice
            </div>
            <div class="salesHome_enjoy_content_box1_text">Cart FAB</div>
            <div class="salesHome_enjoy_content_box1_text">Cart drawer</div>
            <div class="salesHome_enjoy_content_box1_text">Cookies Bar</div>
            <div class="salesHome_enjoy_content_box1_text">Quick checkout</div>
            <div class="salesHome_enjoy_content_box1_text">CTA pop-ups</div>
            <div class="salesHome_enjoy_content_box1_text">
              Emojis/images falling
            </div>
            <div class="salesHome_enjoy_content_box1_text">
              Inactive tab title recall
            </div>
            <div class="salesHome_enjoy_content_box1_text">
              Announcement bar
            </div>
            <div class="salesHome_enjoy_content_box1_text">
              Quick add to cart button
            </div>
            <div class="salesHome_enjoy_content_box1_text">
              Scroll to top button
            </div>
            <div class="salesHome_enjoy_content_box1_text">
              Add to cart button animation
            </div>
            <div class="salesHome_enjoy_content_box1_text">
              Terms of service confirmation
            </div>
            <div
              class="salesHome_enjoy_content_box1_button"
              @click="goLink('https://apps.shopify.com/salesdish')"
            >
              Start your 14-day free trial
            </div>
          </div>
          <div class="salesHome_enjoy_content_box2" v-if="ismobile==false">
            <div class="salesHome_enjoy_content_box2_title">Other apps</div>
            <div class="salesHome_enjoy_content_box2_subtitle">
              $154.25<span>/mo</span>
            </div>
            <div class="salesHome_enjoy_content_box2_line"></div>
            <div class="salesHome_enjoy_content_box2_content">
              <div class="salesHome_enjoy_content_box2_content1">
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img1.png" />Recently
                  viewed
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img2.png" />Sales
                  Notification
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img3.png" />Fixed Add
                  To Cart Bar PRO
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img4.png" />Bag: Cart
                  Drawer
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img5.png" />GDPR/CCPA
                  Compliance Manager
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img6.png" />One Click
                  Checkout
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img7.png" />Sales Pop
                  up ‑ Conversion Pro
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img8.png" />Recently
                  sales notice
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img9.png" />Please Stay
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img10.png" />All
                  Announcement Bars & Banner
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img11.png" />Add to
                  cart button ‑ Nice
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img12.png" />Better
                  Scroll To Top
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img13.png" />Cart
                  Animator
                </div>
                <div class="salesHome_enjoy_content_box2_text">
                  <img src="/static/imgs/salesHome_enjoy_img14.png" />Agree
                  Terms and Conditions
                </div>
              </div>
              <div class="salesHome_enjoy_content_box2_content2">
                <div class="salesHome_enjoy_content_box2_text2">$5.99/mo</div>
                <div class="salesHome_enjoy_content_box2_text2">$4.99/mo</div>
                <div class="salesHome_enjoy_content_box2_text2">$4.99/mo</div>
                <div class="salesHome_enjoy_content_box2_text2 h29">$28/mo</div>
                <div class="salesHome_enjoy_content_box2_text2">$4.90/mo</div>
                <div class="salesHome_enjoy_content_box2_text2">$9.95/mo</div>
                <div class="salesHome_enjoy_content_box2_text2">$29.99/mo</div>
                <div class="salesHome_enjoy_content_box2_text2 h29">
                  $3.99/mo
                </div>
                <div class="salesHome_enjoy_content_box2_text2">$9.99/mo</div>
                <div class="salesHome_enjoy_content_box2_text2">$29.99/mo</div>
                <div class="salesHome_enjoy_content_box2_text2 h29">
                  $9.99/mo
                </div>
                <div class="salesHome_enjoy_content_box2_text2">$4.99/mo</div>
                <div class="salesHome_enjoy_content_box2_text2">$2.5/mo</div>
                <div class="salesHome_enjoy_content_box2_text2">$3.99/mo</div>
              </div>
            </div>
          </div>
          <img src="../assets/home6.svg"  class="salesHome_enjoy_img " alt="" v-else>
        </div>
      </div>
    </div>

    <div class="salesHome_say">
      <div class="salesHome_say_box">
        <div class="salesHome_say_title">Listen to what others say.</div>
        <div class="salesHome_say_subtitle">
          Your feedback is very important to us, if you have any ideas, please
          feel free to communicate with us.
        </div>
        <div class="salesHome_say_content">
          <div
            class="salesHome_say_left"
            @click="clickLeft"
            @mouseover="slideOver"
            @mouseout="slideOut"
          >
            <img src="../assets/arrow_left.svg" alt="" />
          </div>
          <div class="salesHome_say_line">
            <div
              id="slide"
              class="salesHome_say_line_item"
              v-for="(item, index) in sayList"
              :key="index"
              :style="{
                transform: `translateX(${-sayIndex * 406 - 20 + 'px'})`,
              }"
              @mouseenter="slideOver"
              @mouseleave="slideOut"
            >
              <div class="salesHome_say_line_img">
                <img :src="item.icon" alt="" />
              </div>
              <div class="salesHome_say_line_title">{{ item.name }}</div>
              <div class="salesHome_say_line_country">{{ item.country }}</div>
              <div class="salesHome_say_line_star"><img src="../assets/homestar.svg" alt=""></div>
              <div class="salesHome_say_line_content">{{ item.content }}</div>
            </div>
          </div>
          <div
            class="salesHome_say_right"
            @click="clickRight"
            @mouseover="slideOver"
            @mouseout="slideOut"
          >
            <img src="../assets/arrow_right.svg" alt="" />
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./common/header.vue";
import Footer from "./common/footer.vue";

export default {
  name: "SalesHome",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      sayList: [
        {
          icon: "/static/imgs/salesHome_say_img1.png",
          name: "Alex James Flowers",
          country: "from Salt Lake City, USA",
          content:
            '"I tried a lot of apps, this one is really great and support is very good. I suggest that everyone should try this app!  Their customer support is the best I have ever worked with. We encountered a glitch during  installation. I contacted them via email and everything was fine after 20 minutes! "',
        },
        {
          icon: "/static/imgs/salesHome_say_img2.png",
          name: "Ogasawara Katsumi",
          country: "from Sokothai, Thailand",
          content:
            '"I really like way this app works. Many functions are built into one app. In addition, great customizable features and rich options."',
        },
        {
          icon: "/static/imgs/salesHome_say_img3.png",
          name: "Lamb Grocery Store",
          country: "from Buenos Aires, Argentina",
          content:
            '"Announcement bar is just awesome! I recommend it for everybody who is looking for an affordable and easy-to-use tool for notifying customers of some important news. I run my sales every three months and already have a list of my own announcement bar. Needless to say that Announcement bar dramatically increases my profit."',
        },
        {
          icon: "/static/imgs/salesHome_say_img4.png",
          name: "Avicoc",
          country: "from Accra, Ghana",
          content:
            '"Good service, easy to contact and understand what you\'re saying. Support staff in a short time a good solution to my problem! I allowed them to change store settings, they fixed it, I just need to write them a message."',
        },
        {
          icon: "/static/imgs/salesHome_say_img5.png",
          name: "Warcraft Coffee",
          country: "from Fortaleza, Brazil",
          content:
            '"Good and madness, make my store great again, many orders comes in my store, really hope it can help everyone. CTA pop-ups is highly recommended, you will understand how good it is after using it."',
        },
        {
          icon: "/static/imgs/salesHome_say_img6.png",
          name: "Coveted coupons",
          country: "from Houston, USA",
          content:
            '"The app is easy to use and good value for money. I want to see which customers put something in their shopping cart, so that we can contact them and see why they don’t buy, it can meet all my needs."',
        },
      ],
      sayIndex: 0,
      screenWidth: window.innerWidth,
      slideshow: undefined,
      handleScrollFlag: true,
      time: undefined,
      changeSayTimer: undefined,
      ismobile:false
    };
  },
  methods: {
    enlargeSayList() {
      this.sayList.unshift(
        this.sayList[this.sayList.length - 2],
        this.sayList[this.sayList.length - 1]
      );
      // this.sayList.push =
      this.sayList[this.sayList.length] = this.sayList[2];
      this.sayIndex = 2;
    },
    clickLeft() {
      let date1 = new Date().getTime();
      if (!this.time || this.time < date1 - 500) {
        this.time = date1;
        if (this.sayIndex == 0) {
          for (let i = 0; i < this.sayList.length; i++) {
            document.querySelector(".salesHome_say_line_item").className =
              "salesHome_say_line_item_no_transition";
          }
          this.sayIndex = this.sayList.length - 3;
          this.changeSayTimer = setTimeout(this.changeSeamless, 500);
        } else {
          this.sayIndex--;
        }
      }
    },
    clickRight() {
      let date1 = new Date().getTime();
      if (!this.time || this.time < date1 - 500) {
        this.time = date1;
        if (this.sayIndex == this.sayList.length - 3) {
          for (let i = 0; i < this.sayList.length; i++) {
            document.querySelector(".salesHome_say_line_item").className =
              "salesHome_say_line_item_no_transition";
          }
          this.sayIndex = 0;
          this.changeSayTimer = setTimeout(this.changeSeamless, 500);
        } else {
          this.sayIndex++;
        }
      }
    },
    handleScrollHome() {
      if (
        this.handleScrollFlag &&
        this.screenWidth > 767 &&
        document.querySelector(".salesHome_say_box")
      ) {
        var exp_height = document
          .querySelector(".home_say_box")
          .getBoundingClientRect().top;
        clearInterval(this.slideshow);
        if (exp_height < 450 && exp_height > -300) {
          this.handleScrollFlag = false;
          this.slideshow = setInterval(this.clickRight, 2000);
        }
      }
    },
    changeSeamless() {
      clearTimeout(this.changeSayTimer);
      if (this.sayIndex == 0) {
        for (let i = 0; i < this.sayList.length; i++) {
          document.querySelector(
            ".salesHome_say_line_item_no_transition"
          ).className = "salesHome_say_line_item";
        }
        this.sayIndex++;
      } else {
        for (let i = 0; i < this.sayList.length; i++) {
          document.querySelector(
            ".salesHome_say_line_item_no_transition"
          ).className = "salesHome_say_line_item";
        }
        this.sayIndex--;
      }
    },
    slideOver() {
      if (this.screenWidth > 767) {
        clearInterval(this.slideshow);
      }
    },
    slideOut() {
      if (this.screenWidth > 767) {
        // this.clickRight()
        this.slideshow = setInterval(this.clickRight, 2000);
      }
    },
    liveChat() {
      if (window.fcWidget) {
        window.fcWidget.open();
      }
    },
    goToPrice() {
      // console.log(this.$route)
      if (document.querySelector(".salesHome_enjoy_content")) {
        this.goToPriceScroll();
      } else {
        let waitEleTimer = setInterval(() => {
          if (document.querySelector(".salesHome_enjoy_content")) {
            clearInterval(waitEleTimer);
            this.goToPriceScroll();
          }
        }, 100);
      }
    },
    goToPriceScroll() {
      if (this.$route.hash === "#price") {
        let start =
          document.documentElement.scrollTop || document.body.scrollTop;
        let end =
          document
            .querySelector(".salesHome_enjoy_content")
            .getBoundingClientRect().top - 100;
        // console.log(end)
        let step = end / 220;
        let d = step;
        let count = 0;
        let timer = setInterval(() => {
          if (count > 30 && count <= 70) {
            d = 3 * step;
          } else if (count > 10 && count <= 90) {
            d = 2 * step;
          } else if (count > 0 && count < 100) {
            d = step;
          }
          start += d;
          window.scrollTo(0, start);
          count++;
          if (count >= 100) {
            clearInterval(timer);
          }
        }, 10);
        window.location.hash = "#pricing";
      } else if (this.$route.hash === "") {
      }
    },
    goLink(url) {
      window.open(url);
    },
  },
  created() {
    if(document.body.offsetWidth>767){
      this.ismobile=false
      this.enlargeSayList();
    }else{
      this.ismobile=true
    }
    if (this.$route.path === "/home") {
      this.goToPrice();
    }
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (this.$route.path === "/home") {
        this.goToPrice();
      }
    },
  },
  deactivated() {
    if (this.isMobileHome) {
      window.removeEventListener("scroll", this.keyRollChange, true);
    } else {
      window.removeEventListener("scroll", this.handleScrollHome);
      if (this.slideshow) {
        window.clearInterval(this.slideshow);
      }
    }
  },
};
</script>

<style scoped>
.salesHome {
  overflow: hidden;
}
.salesHome_app {
  width: 1200px;
  margin: auto;
}
.salesHome_top_background {
  width: 100%;
  height: 525px;
  background: url(../assets/saleshome_top.svg) no-repeat center center;
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.salesHome_top_title {
  width: 100%;
  height: 40px;
  font-size: 40px;
  font-weight: Bold;
  text-align: center;
  margin-top: 125px;
}
.salesHome_top_title span {
  color: #01c4c7;
}
.salesHome_top_subtitle {
  width: 100%;
  height: 40px;
  font-size: 40px;
  font-weight: Bold;
  text-align: center;
  line-height: 100%;
  margin-top: 29px;
}
.salesHome_top_subtitle span {
  color: #01c4c7;
}
.salesHome_top_button {
  width: 100%;
  text-align: center;
  display: flex;
  padding-top: 74px;
  justify-content: center;
}
.salesHome_top_button_1 {
  width: 259px;
  height: 50px;
  background-color: #01c4c7;
  box-shadow: 0px 6px 8px 0px rgba(1, 196, 199, 0.1);
  cursor: pointer;
  font-size: 18px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
}
.salesHome_top_button_2 {
  width: 238px;
  height: 50px;
  box-shadow: 0px 6px 8px 0px rgba(1, 196, 199, 0.1);
  border-radius: 4px;
  border: 2px solid #01c4c7;
  margin-left: 26px;
  cursor: pointer;
  font-size: 18px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #01c4c7;
  display: flex;
  justify-content: center;
  align-items: center;
}
.salesHome_top_button_2 span{
  margin-right: 10px;
}
.salesHome_difficulties {
  height: 1383px;
  background: #f9fbff;
}
.salesHome_difficulties_box {
  flex-direction: column;
  width: 1200px;
  margin: 0 auto;
}
.salesHome_difficulties_title {
  padding: 90px 0 90px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  text-align: center;
}
.salesHome_difficulties_content_title {
  font-size: 24px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
}
.salesHome_difficulties_content_img {
  width: 385px;
  height: 400px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  position: relative;
  margin-top: 40px;
}
.salesHome_difficulties_content_img img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.salesHome_difficulties_content_text {
  height: 48px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
  border-radius: 29px;
  font-size: 18px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #0c0546;
  line-height: 48px;
  text-align: center;
  padding-right: 30px;
}
.salesHome_difficulties_content_text span {
  color: #01c4c7;
}
.salesHome_difficulties_content_text img {
  padding: 0 15px 0 20px;
}
.salesHome_difficulties_content_text.d1 {
  width: 444px;
  position: relative;
  left: 427px;
  top: -368px;
}
.salesHome_difficulties_content_text.d2 {
  width: 444px;
  position: relative;
  left: 349px;
  top: -300px;
}
.salesHome_difficulties_content_text.d3 {
  width: 380px;
  position: relative;
  left: 427px;
  top: -232px;
}
.salesHome_difficulties_content_text.d4 {
  width: 369px;
  position: relative;
  left: 338px;
  top: -164px;
}
.salesHome_difficulties_content_2 {
  margin-top: -100px;
  text-align: right;
}
.salesHome_difficulties_content_img2 {
  float: right;
}
.salesHome_difficulties_content_img2 img {
  top: 55%;
}
.salesHome_difficulties_content_text.d5 {
  width: 605px;
  position: relative;
  left: 319px;
  top: 64px;
}
.salesHome_difficulties_content_text.d6 {
  width: 398px;
  position: relative;
  left: 293px;
  top: 135px;
}
.salesHome_difficulties_content_text.d7 {
  width: 450px;
  position: relative;
  left: 393px;
  top: 205px;
}
.salesHome_difficulties_content_text.d8 {
  width: 434px;
  position: relative;
  left: 474px;
  top: 276px;
}
.salesHome_solve_box {
  width: 1200px;
  margin: 0 auto;
}
.salesHome_solve_title {
  height: 40px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  margin-top: 90px;
  text-align: center;
}
.salesHome_solve_subtitle {
  height: 61px;
  font-size: 24px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 28px;
  text-align: center;
  margin: 20px 100px 0;
}
.salesHome_solve_prepare {
  display: flex;
  /* margin-left: 30px; */
}
.salesHome_solve_prepare2 {
  flex-direction: row-reverse;
  /* margin-left: -84px; */
  margin-right: 30px;
}
.salesHome_solve_prepare_img {
  padding-top: 80px;
}
.salesHome_solve_prepare_title {
  width: 450px;
  height: 40px;
  font-size: 24px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  margin-left: 90px;
  margin-bottom: 15px;
}
.salesHome_solve_prepare_title_right {
  margin-left: 30px;
}
.salesHome_solve_prepare_img img {
  margin-left: -30px;
}
.salesHome_solve_prepare_content {
  padding: 72px 0 0 29px;
}
.salesHome_solve_prepare_content2 {
  padding: 72px 0 0 89px;
}
.salesHome_solve_prepare_subtitle {
  height: 24px;
  font-size: 20px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: bold;
  color: #333333;
  line-height: 24px;
  margin-top: 22px;
  display: flex;
  align-items: center;
}
.salesHome_solve_prepare_subtitle div{
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #333333;
  margin-right: 10px;
}
.salesHome_solve_prepare_subtitle_box {
  display: flex;
  flex-wrap: wrap;
  margin: 22px 0 10px 18px;
}
.salesHome_solve_prepare_subtitle_box span {
  color: #01c4c7;
}
.salesHome_solve_prepare_text {
  width: 240px;
  height: 40px;
  font-size: 16px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #333333;
  line-height: 19px;
  display: flex;
  align-items: center;
}
.salesHome_solve_prepare_text img{
  margin-right: 8px;
}
.salesHome_solve_prepare_line {
  width: 507px;
  border-bottom: 1px solid #cbcbcb;
}
.salesHome_install {
  background: #f9fbff;
  height: 342px;
}
.salesHome_install_box {
  width: 1200px;
  margin: auto;
}
.salesHome_install_content {
  display: flex;
  justify-content: space-between;
}
.salesHome_install_text {
  margin-top: 90px;
}
.salesHome_install_title {
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
}
.salesHome_install_subtitle {
  width: 681px;
  font-size: 24px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 28px;
  padding-top: 25px;
}
.salesHome_install_button {
  width: 259px;
  height: 50px;
  background: #01c4c7;
  box-shadow: 0px 6px 8px 0px rgba(1, 196, 199, 0.1);
  border-radius: 4px;
  text-align: center;
  line-height: 50px;
  margin-top: 90px;
}
.salesHome_install_button_text {
  height: 20px;
  font-size: 18px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.salesHome_app {
  height: 1079px;
}
.salesHome_app_box {
  width: 1200px;
  margin: auto;
}
.salesHome_app_title {
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  padding: 89px 0 90px;
  text-align: center;
}
.salesHome_app_content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.salesHome_app_content_box {
  width: 386px;
  height: 325px;
  background: #ffffff;
  box-shadow: 0px 0px 13px 0px rgba(168, 168, 168, 0.15);
  border-radius: 20px;
  border: 1px solid rgba(1, 196, 199, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
}
.salesHome_app_content_box:hover {
  box-shadow: 0 0.1rem 0.08rem 0 rgba(156, 156, 156, 0.22),
    0 0.05rem 0.04rem 0 rgba(167, 167, 167, 0.06);
}
.salesHome_app_content_box img {
  margin-top: 30px;
  height: 122px;
}
.salesHome_app_content_title {
  height: 28px;
  font-size: 20px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 600;
  color: #222536;
  line-height: 28px;
  text-align: center;
  margin-top: 18px;
}
.salesHome_app_content_subtitle {
  width: 352px;
  font-size: 16px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #8d919b;
  line-height: 24px;
  text-align: center;
  margin-top: 18px;
}
.salesHome_app_subtitle {
  height: 40px;
  font-size: 20px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 40px;
  text-align: center;
  margin-top: 10px;
}
.salesHome_support {
  height: 349px;
  background: #2836cd;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
}
.salesHome_support_box {
  width: 1200px;
  margin: auto;
}
.salesHome_support_title {
  height: 40px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  padding: 90px 0 100px;
}
.salesHome_support_content {
  display: flex;
  align-items: center;
}
.salesHome_support_content img {
  padding-left: 357px;
  padding-right: 50px;
}
.salesHome_support_team {
  height: 78px;
}
.salesHome_support_team_text {
  height: 20px;
  font-size: 14px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  position: relative;
  left: 450px;
  top: -25px;
}
.salesHome_support_button {
  width: 127px;
  height: 50px;
  box-shadow: 0px 6px 8px 0px rgba(1, 196, 199, 0.1);
  border-radius: 4px;
  border: 2px solid #ffffff;
  font-size: 18px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 500;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
}
.salesHome_enjoy {
  height: 1468px;
}
.salesHome_enjoy_box {
  width: 1200px;
  margin: auto;
}
.salesHome_enjoy_title {
  display: flex;
  margin-bottom: 106px;
}
.salesHome_enjoy_title_text {
  margin-left: 30px;
}
.salesHome_enjoy_title_title {
  width: 750px;
  height: 40px;
  font-size: 40px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  margin: 96px 0 45px;
}
.salesHome_enjoy_title_subtitle {
  height: 38px;
  font-size: 32px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 38px;
}
.salesHome_enjoy_title_button {
  width: 259px;
  height: 50px;
  background: #01c4c7;
  box-shadow: 0px 6px 8px 0px rgba(1, 196, 199, 0.1);
  border-radius: 4px;
  font-size: 18px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
  margin: 90px 0 0 161px;
  cursor: pointer;
}
.salesHome_enjoy_content {
  display: flex;
}
.salesHome_enjoy_content_box1 {
  width: 480px;
  height: 912px;
  background: #ffffff;
  box-shadow: 4px 4px 35px 0px rgba(135, 135, 135, 0.2);
  border-radius: 16px;
  text-align: center;
  margin-left: 111px;
}
.salesHome_enjoy_content_box1 img {
  margin: 43px 0 3px;
}
.salesHome_enjoy_content_box1_title {
  height: 49px;
  font-size: 42px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #01c4c7;
  line-height: 49px;
  margin-bottom: 24px;
}
.salesHome_enjoy_content_box1_title span {
  font-size: 26px;
  font-family: Helvetica;
  font-weight: Regular;
}
.salesHome_enjoy_content_box1_line {
  width: 390px;
  border-bottom: 1px solid #cbcbcb;
  margin: 0 0 46px 45px;
}
.salesHome_enjoy_content_box1_text {
  height: 20px;
  font-size: 18px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 500;
  color: #222536;
  line-height: 18px;
  margin-bottom: 20px;
}
.salesHome_enjoy_content_box1_button {
  width: 263px;
  height: 50px;
  box-shadow: 0px 6px 8px 0px rgba(1, 196, 199, 0.1);
  border-radius: 4px;
  border: 2px solid #01c4c7;
  font-size: 18px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 500;
  color: #01c4c7;
  line-height: 50px;
  margin: 39px 110px 0 110px;
  cursor: pointer;
}
.salesHome_enjoy_content_box2 {
  width: 480px;
  height: 912px;
  text-align: center;
  margin-left: 60px;
}
.salesHome_enjoy_content_box2_title {
  font-size: 32px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 600;
  color: #333333;
  line-height: 38px;
  margin: 57px 0 17px;
}
.salesHome_enjoy_content_box2_subtitle {
  height: 49px;
  font-size: 42px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #333333;
  line-height: 49px;
  margin-bottom: 24px;
}
.salesHome_enjoy_content_box2_subtitle span {
  font-size: 26px;
  font-family: Helvetica;
  font-weight: Regular;
}
.salesHome_enjoy_content_box2_line {
  width: 410px;
  border-bottom: 1px solid #cbcbcb;
  margin: 0 0 46px 35px;
}
.salesHome_enjoy_content_box2_content {
  display: flex;
  text-align: left;
}
.salesHome_enjoy_content_box2_content1 {
  width: 367px;
  margin-left: 20px;
}
.salesHome_enjoy_content_box2_text {
  margin: 0 0 20px 0;
}
.salesHome_enjoy_content_box2_text img {
  width: 28px;
  height: 28px;
  margin-right: 12px;
}
.salesHome_enjoy_content_box2_text #text {
  font-size: 16px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 500;
  color: #333333;
  line-height: 28px;
}
.salesHome_enjoy_content_box2_text2 {
  font-size: 16px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 500;
  color: #333333;
  line-height: 28px;
  margin-bottom: 20px;
}
.salesHome_enjoy_content_box2_text2.h29 {
  line-height: 29px;
}
.salesHome_say {
  height: 851px;
  background: #f9fbff;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
}
.salesHome_say_box {
  height: 851px;
  width: 1200px;
  margin: auto;
}
.salesHome_say_title {
  height: 40px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  padding: 90px 0 60px;
  text-align: center;
}
.salesHome_say_subtitle {
  font-size: 24px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 28px;
  text-align: center;
  margin-bottom: 72px;
}
.salesHome_say_content {
  position: relative;
}
.salesHome_say_left {
  width: 48px;
  height: 48px;
  background: #f9fbff;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: -58px;
  transform: translate(0, -50%);
  /* cursor: not-allowed; */
}
.salesHome_say_left:hover {
  content: url(../assets/arrow_left_hover.svg);
  cursor: pointer;
}
.salesHome_say_right {
  width: 48px;
  height: 48px;
  background: #f9fbff;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  right: -58px;
  transform: translate(0, -50%);
  /* cursor: not-allowed; */
}
.salesHome_say_right:hover {
  content: url(../assets/arrow_right_hover.svg);
  cursor: pointer;
}
.salesHome_say_line {
  display: flex;
  overflow: hidden;
  justify-content: space-between;
  text-align: center;
}
.salesHome_say_line_item {
  flex: none;
  width: 386px;
  height: 511px;
  background: #ffffff;
  box-shadow: 0px 10px 18px 0px rgba(213, 213, 213, 0.2);
  border-radius: 20px;
  transition: all 0.8s;
  margin-left: 20px;
}
.salesHome_say_line_item_no_transition {
  flex: none;
  width: 386px;
  height: 511px;
  background: #ffffff;
  box-shadow: 0px 10px 18px 0px rgba(213, 213, 213, 0.2);
  border-radius: 20px;
  margin-left: 20px;
}
.salesHome_say_line_img img {
  width: 88px;
  height: 88px;
  margin: 34px 0 30px;
}
.salesHome_say_line_title {
  font-size: 24px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 28px;
  margin-bottom: 14px;
}
.salesHome_say_line_country {
  font-size: 18px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #8d919b;
  line-height: 21px;
  margin-bottom: 20px;
}
.salesHome_say_line_star {
  margin-bottom: 25px;
}
.salesHome_say_line_star img{
  width: 220px;
}
.salesHome_say_line_content {
  width: 320px;
  font-size: 16px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #8d919b;
  line-height: 26px;
  margin: auto;
}
@media (max-width: 767px) {
  .salesHome_top {
    width: 100%;
    padding: 1.05rem 0 0.64rem;
    background: rgba(1, 196, 199, 0.06);
  }
  .salesHome_app {
    width: 100%;
  }
  .salesHome_top_background {
    width: 100%;
    height: auto;
    padding: 1.14rem 0.48rem 0;
    background: none;
    display: block;
  }
  .salesHome_top_title {
    height: auto;
    font-family: Helvetica-Bold;
    line-height: 0.53rem;
    font-weight: 700;
    font-size: 0.44rem;
    margin-top: 0;
  }
  .salesHome_top_title span {
    color: #01c4c7;
  }
  .salesHome_top_subtitle {
    font-family: Helvetica-Bold;
    font-size: 0.4rem;
    font-weight: 700;
    height: auto;
    margin-top: 0.16rem;
    line-height: initial;
  }
  .salesHome_top_subtitle span {
    color: #01c4c7;
  }
  .salesHome_top_button {
    display: block;
    padding-top: 0.5rem;
  }
  .salesHome_top_button_1 {
    width: 5.2rem;
    height: 0.96rem;
    box-shadow: 0px 0.09rem 0.12rem 0px rgba(252, 83, 34, 0.1);
    border-radius: 0.08rem;
    font-family: Helvetica-Bold;
    font-size: 0.28rem;
    font-weight: 700;
    line-height: .96rem;
    margin: 0 auto;
  }
  .salesHome_top_button_2 {
    width: 5.2rem;
    height: 0.96rem;
    border: 0.02rem solid rgba(1, 196, 199, 1);
    box-shadow: 0px 0.09rem 0.12rem 0px rgba(252, 83, 34, 0.1);
    border-radius: 0.08rem;
    margin-left: 0;
    font-family: Helvetica-Bold;
    font-size: 0.28rem;
    font-weight: 700;
    margin: 0.24rem auto 0;
  }
  .salesHome_top_button_2 span{
    margin-left:.05rem ;
  }
  .salesHome_topimg{
    width: 100%;
    margin-top: .5rem;
  }
  .salesHome_difficulties {
    height: auto;
  }
  .salesHome_difficulties_box {
    width: 100%;
    padding: .8rem .48rem .9rem;
  }
  .salesHome_difficulties_title {
    padding:0;
    font-weight: 700;
    font-size: .48rem;
    line-height: initial;
  }
  .salesHome_difficulties_content_1{
    margin-top:.79rem
  }
  .salesHome_difficulties_box img{
    width: 100%;
  }
  .salesHome_difficulties_content_title {
    font-size: .3rem;
    font-weight: 700;
    color: #222536;
    line-height: initial;
    margin-bottom: .59rem;
  }
  .salesHome_difficulties_content_2 {
    margin-top: .94rem;
    text-align: right;
  }
  .salesHome_solve_box {
    width: 100%;
    padding: .8rem .48rem 1rem;
    margin: 0 auto;
  }
  .salesHome_solve_title {
    height:auto;
    font-size: .48rem;
    font-weight: 700;
    line-height: initial;
    margin-top:0;
  }
  .salesHome_solve_subtitle {
    width: 90%;
    height: auto;
    font-size: .24rem;
    font-weight: 400;
    color:#8D919B;
    line-height: .36rem;
    margin: .44rem auto .79rem;
  }
  .salesHome_solve_prepare {
    display: block;
  }
  .salesHome_solve_prepare2 {
    margin-right: 0;
  }
  .salesHome_solve_prepare_img {
    padding-top: 0;
  }
  .salesHome_solve_prepare_title {
    width: auto;
    height: auto;
    font-size: .3rem;
    font-weight: 700;
    line-height: auto;
    margin-left: 0;
    margin-bottom: .59rem;
  }
  .salesHome_solve_prepare_title_right {
    margin-left: 0;
  }
  .salesHome_solve_prepare_content {
    padding: 0;
  }
  .salesHome_solve_prepare_content2 {
    padding:0;
  }
  .salesHome_solve_prepare_subtitle {
    height: auto;
    font-size: .24rem;
    font-weight: 700;
    color: #333333;
    line-height: initial;
    margin-top: 0;
  }
  .salesHome_solve_prepare_subtitle div{
    width: .12rem;
    height: .12rem;
    margin-right: .11rem;
  }
  .salesHome_solve_prepare_subtitle_box {
    margin: .42rem 0 .2rem .23rem;
    justify-content: space-between;
  }
 .salesHome_solve_prepare_text {
    width: 48%;
    height: auto;
    font-size: .22rem;
    line-height: .24rem;
    margin-bottom: .22rem;
    align-items: flex-start;
  }
  .salesHome_solve_prepare_text img{
    margin-right: .08rem;
    width: .15rem;
    height: .15rem;
    margin-top:.03rem
  }
  .salesHome_solve_prepare_line {
    width: 100%;
    margin-bottom: .475rem;
  }
  .salesHome_solveimg{
    width: 6rem;
    margin:.38rem 0 .79rem -.48rem;
  }
  .salesHome_solveimg2{
    width: 6rem;
    margin:.38rem auto 0;
    display: block;
  }
  .salesHome_install {
    height: auto;
  }
  .salesHome_install_box {
    width: 100%;
    margin: auto;
    padding: 1rem .48rem;
  }
  .salesHome_install_content {
    display: block;
  }
  .salesHome_install_text {
    margin-top: 0;
  }
  .salesHome_install_title {
    font-family: Helvetica-Bold;
    font-size: .48rem;
    text-align: center;
    line-height: .58rem;
    font-weight: 700;
  }
  .salesHome_install_subtitle {
    width: 5.25rem;
    font-size: .24rem;
    line-height: .36rem;
    text-align: center;
    margin: .24rem auto .4rem;
  }
  .salesHome_install_button {
    width: 3.38rem;
    height: .56rem;
    background: #01c4c7;
    box-shadow: 0px .06rem .08rem 0px rgba(1, 196, 199, 0.1);
    border-radius: .04rem;
    text-align: center;
    line-height: .56rem;
    margin: 0 auto;
  }
  .salesHome_install_button_text {
    height: auto;
    font-size: .24rem;
  }
  .salesHome_app {
    height: auto;
  }
  .salesHome_app_box {
    width: 100%;
    margin: auto;
    padding: 1rem .48rem .8rem;
  }
  .salesHome_app_title {
    font-family: Helvetica-Bold;
    font-size: .48rem;
    text-align: center;
    line-height: .58rem;
    font-weight: 700;
    width: 5.7rem;
    padding: 0;
    margin:0 auto .68rem
  }
  .salesHome_app_content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .salesHome_app_content_box {
    width: 100%;
    height: auto;
    padding: .58rem .48rem;
    box-shadow: 0px 0px .24rem 0px rgba(168, 168, 168, 0.15);
    border-radius: .24rem;
    border: 1px solid rgba(1, 196, 199, 0.04);
    margin-bottom: .28rem;
  }
  .salesHome_app_content_box:hover {
    box-shadow: 0 0.1rem 0.08rem 0 rgba(156, 156, 156, 0.22),
      0 0.05rem 0.04rem 0 rgba(167, 167, 167, 0.06);
  }
  .salesHome_app_content_box img {
    margin-top: 0;
    height: 2rem;
    width: 2rem;
  }
  .salesHome_app_content_title {
    height: auto;
    font-size: .36rem;
    font-weight: 700;
    line-height: .28rem;
    margin:.4rem auto .2rem ;
  }
  .salesHome_app_content_subtitle {
    width: auto;
    font-size: .28rem;
    line-height: .38rem;
    text-align: center;
    margin-top: 0;
  }
  .salesHome_app_subtitle {
    opacity: 0.8;
    font-family: Helvetica;
    font-size: .24rem;
    line-height: .4rem;
    font-weight: 400;
    height: auto;
    margin-top: .12rem;
  }
  .salesHome_support {
    height: auto;
    box-shadow: 0px .04rem .08rem 0px rgba(0, 0, 0, 0.05);
  }
  .salesHome_support_box {
    width: 100%;
    margin: auto;
    padding: 1rem .48rem;
  }
  .salesHome_support_title {
    height: auto;
    font-size: .48rem;
    font-weight: 700;
    line-height: .58rem;
    padding:0;
  }
  .salesHome_support_content {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top:.52rem;
  }
  .salesHome_support_content img {
    padding: 0;
    width: 2.74rem;
    height: .76rem;
  }
  .salesHome_support_team {
    height: .76rem;
    margin-right: .78rem;
  }
  .salesHome_support_team_text {
    display: none;
  }
  .salesHome_support_button {
    width: 1.27rem;
    height: .5rem;
    box-shadow: 0px .06rem .08rem 0px rgba(1, 196, 199, 0.1);
    border-radius: .04rem;
    border: .02rem solid #ffffff;
    font-size: .18rem;
    line-height: .5rem;
  }
  .salesHome_enjoy {
    height: auto;
  }
  .salesHome_enjoy_box {
    width: 100%;
    margin: auto;
    padding:1rem .48rem .8rem ;
  }
  .salesHome_enjoy_title {
    display: block;
    margin-bottom: .6rem;
  }
  .salesHome_enjoy_title_text {
    margin-left: 0;
  }
  .salesHome_enjoy_title_title {
    width: auto;
    height: auto;
    font-size: .48rem;
    font-weight: 700;
    line-height: .58rem;
    margin: 0;
    text-align: center;
  }
  .salesHome_enjoy_title_subtitle {
    height: auto;
    font-size: .24rem;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    line-height: initial;
    margin:.24rem auto .4rem;
    text-align: center;
  }
  .salesHome_enjoy_title_button {
    width: 3.38rem;
    height: .56rem;
    background: #01c4c7;
    box-shadow: 0px .06rem .08rem 0px rgba(1, 196, 199, 0.1);
    border-radius: .04rem;
    text-align: center;
    line-height: .56rem;
    margin: 0 auto;
    font-size: .24rem;
  }
  .salesHome_enjoy_content {
    display: block;
  }
  .salesHome_enjoy_content_box1 {
    width: 100%;
    height: auto;
    background: #ffffff;
    box-shadow: .04rem .04rem .35rem 0px rgba(135, 135, 135, 0.2);
    border-radius: .24rem;
    margin-left: 0;
    padding: 0 .63rem .6rem;
    margin-bottom:.4rem;
  }
  .salesHome_enjoy_content_box1 img {
    margin: .6rem 0 .16rem;
  }
  .salesHome_enjoy_content_box1_title {
    height: auto;
    font-size: .52rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: 700;
    line-height: initial;
    margin-bottom: .24rem;
  }
  .salesHome_enjoy_content_box1_title span {
    font-size: .26rem;
    font-family: Helvetica;
    font-weight: 400;
  }
  .salesHome_enjoy_content_box1_line {
    width: 100%;
    border-bottom: 1px solid #cbcbcb;
    margin: 0 0 .555rem 0;
  }
  .salesHome_enjoy_content_box1_text {
    height: auto;
    font-size: .22rem;
    font-family: Helvetica-Medium, Helvetica;
    font-weight: 700;
    line-height: initial;
    margin-bottom: .28rem;
  }
  .salesHome_enjoy_content_box1_button {
    width: 2.57rem;
    height: .5rem;
    box-shadow: 0px .06rem .08rem 0px rgba(1, 196, 199, 0.1);
    border-radius: .04rem;
    border: 2px solid #01c4c7;
    font-size: .18rem;
    font-family: Helvetica-Medium, Helvetica;
    font-weight: 400;
    line-height: .5rem;
    margin: .4rem auto 0;
  }
  .salesHome_enjoy_img{
    width: 100%;
  }
  .salesHome_say {
    height: auto;
    box-shadow: 0px .04rem .08rem 0px rgba(0, 0, 0, 0.05);
  }
  .salesHome_say_box {
    height: auto;
    width: 100%;
    margin: auto;
    padding:1rem .48rem 
  }
  .salesHome_say_title {
    height: auto;
    font-size: .48rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: 700;
    line-height: .58rem;
    padding: 0;
  }
  .salesHome_say_subtitle {
    font-size: .24rem;
    font-family: Helvetica-Regular, Helvetica;
    line-height: .36rem;
    margin: .24rem auto .6rem;
    width: 5.17rem;
  }
  .salesHome_say_left {
    display: none;
  }
  .salesHome_say_right {
   display: none;
  }
  .salesHome_say_line {
    overflow: auto;
  }
  .salesHome_say_line_item {
    flex: none;
    width: 100%;
    height: auto;
    box-shadow: 0px .1rem .18rem 0px rgba(213, 213, 213, 0.2);
    border-radius: .24rem;
    margin-left: 0;
    padding: .68rem .48rem;
    transform: translateX(0)!important;
  }
  .salesHome_say_line_item + .salesHome_say_line_item {
    margin-left: .2rem;
  }
  .salesHome_say_line_img img {
    width: 2rem;
    height: 2rem;
    margin: 0;
  }
  .salesHome_say_line_title {
    font-size: .36rem;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 700;
    line-height: initial;
    margin: .44rem auto .2rem;
  }
  .salesHome_say_line_country {
    font-size: .24rem;
    font-family: Helvetica-Regular, Helvetica;;
    line-height: initial;
    margin-bottom: .24rem;
  }
  .salesHome_say_line_star {
    margin-bottom: .24rem;
  }
  .salesHome_say_line_star img{
    width: 2.37rem;
    height:.36rem ;
  }
  .salesHome_say_line_content {
    width: auto;
    font-size: .28rem;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    line-height: .38rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/salesHome.vue